import { FieldStyle } from './fieldstyle';
export class DataFormat {
  colName: string;
  displayName: string;
  fieldValue: string;
  flatKeyValue: any;
  dataType: string;
  thousandSepartor: string;
  decimalPlaces: number;
  currencySymbol: string;
  dateFormat: string;
  header: FieldStyle;
  cell: FieldStyle;
}
